import { type VariantProps } from "class-variance-authority";
import { Minus, Plus, Settings } from "lucide-react";
import React from "react";

import { iconContainerVariants } from "./history-entry-card-variants";

import { RelativeTime } from "@/components/ui/v2/relative-time";
import { cn } from "@/lib/utils/cn";

const VARIANT_ICONS = {
  update: Settings,
  created: Plus,
  destructive: Minus,
} as const;

type HistoryEntryIconProps = VariantProps<typeof iconContainerVariants>;

export function HistoryEntryIcon({ variant = "update" }: HistoryEntryIconProps) {
  const Icon = VARIANT_ICONS[variant!];

  return (
    <div className={cn(iconContainerVariants({ variant }))}>
      <Icon className="h-5 w-5" />
    </div>
  );
}

type HistoryEntryCardProps = HistoryEntryIconProps & {
  description: React.ReactNode;
  occurredAt?: string;
  count?: string;
};

export function HistoryEntryCard({
  description,
  occurredAt,
  count,
  variant,
}: HistoryEntryCardProps) {
  return (
    <div data-slot="panel" className="flex items-start gap-3 rounded-lg border bg-card p-3 h-full w-full">
      <div className="flex h-full items-center">
        <HistoryEntryIcon variant={variant} />
      </div>
      <div className="flex flex-col">
        <p className="text-sm">{description}</p>
        <div className="mt-1 flex items-center gap-2 text-xs text-muted-foreground">
          {occurredAt && <RelativeTime date={occurredAt} />}
          {occurredAt && count && <span>|</span>}
          {count && <span>{count}</span>}
        </div>
      </div>
    </div>
  );
}
